"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateCreateClusterAgentBuildingPacket = exports.generateCreateClusterAgentAction = void 0;
const lumos_1 = require("@ckb-lumos/lumos");
const codec_1 = require("@ckb-lumos/codec");
const sporeAction_1 = require("../../codec/sporeAction");
const buildingPacket_1 = require("../../codec/buildingPacket");
const buildingPacket_2 = require("../../base/buildingPacket");
const sporeScriptInfo_1 = require("../../base/sporeScriptInfo");
const referenceClusterProxy_1 = require("../clusterProxy/referenceClusterProxy");
function generateCreateClusterAgentAction(props) {
    const actions = [];
    const scriptInfos = [];
    let txSkeleton = props.txSkeleton;
    const clusterOutput = txSkeleton.get('outputs').get(props.outputIndex);
    const clusterAgentType = clusterOutput.cellOutput.type;
    const clusterAgentTypeHash = lumos_1.utils.computeScriptHash(clusterAgentType);
    const scriptInfo = (0, sporeScriptInfo_1.createSporeScriptInfoFromTemplate)({
        scriptHash: clusterAgentTypeHash,
    });
    scriptInfos.push(scriptInfo);
    const actionData = sporeAction_1.SporeAction.pack({
        type: 'CreateClusterAgent',
        value: {
            clusterId: clusterAgentType.args,
            clusterProxyId: props.clusterProxyId,
            to: {
                type: 'Script',
                value: clusterOutput.cellOutput.lock,
            },
        },
    });
    actions.push({
        scriptInfoHash: lumos_1.utils.ckbHash(buildingPacket_1.ScriptInfo.pack(scriptInfo)),
        scriptHash: clusterAgentTypeHash,
        data: codec_1.bytes.hexify(actionData),
    });
    const clusterAction = (0, referenceClusterProxy_1.generateReferenceClusterProxyAction)({
        txSkeleton,
        referenceType: props.reference.referenceType,
        clusterProxy: props.reference.clusterProxy,
    });
    actions.push(...clusterAction.actions);
    scriptInfos.push(...clusterAction.scriptInfos);
    return {
        actions,
        scriptInfos,
    };
}
exports.generateCreateClusterAgentAction = generateCreateClusterAgentAction;
function generateCreateClusterAgentBuildingPacket(props) {
    let txSkeleton = props.txSkeleton;
    const action = generateCreateClusterAgentAction(props);
    return (0, buildingPacket_2.createRawBuildingPacket)({
        txSkeleton,
        actions: action.actions,
        scriptInfos: action.scriptInfos,
        changeOutput: txSkeleton.get('outputs').size - 1,
    });
}
exports.generateCreateClusterAgentBuildingPacket = generateCreateClusterAgentBuildingPacket;
//# sourceMappingURL=createClusterAgent.js.map